export default __webpack_public_path__ + "static/media/collapse.965c890f.svg";